import { Component } from '@angular/core';

import { ContactSection } from '../../components/main-sections/contact-section/contact-section';
import { ProjectsShowcase } from '../../components/main-sections/projects-showcase/projects-showcase';
import { ServicesSection } from '../../components/main-sections/services-section/services-section';
import { StartPage } from '../start-page/start-page';

@Component({
  selector: 'app-main-page',
  standalone: true,
  imports: [
    StartPage,
    ServicesSection,
    ProjectsShowcase,
    ContactSection,
  ],
  templateUrl: './main-page.html',
  styleUrl: './main-page.scss',
})
export class MainPage {}
